module.exports = __webpack_public_path__ + "static/media/slide_35_left_img.b9c57070.png";